module.exports = __webpack_public_path__ + "img/xbox-one.c5e637a1.png";